import actions from './actions';

const {
  GET_BRAND_BEGIN, GET_BRAND_SUCCESS, GET_BRAND_FAILED,
  ADD_BRAND_BEGIN, ADD_BRAND_SUCCESS, ADD_BRAND_FAILED,
  GET_VEHICLES_BRAND_SUCCESS, GET_VEHICLES_BRAND_BEGIN, GET_VEHICLES_BRAND_FAILED,
  UPDATE_BRAND_BEGIN, UPDATE_BRAND_SUCCESS, UPDATE_BRAND_FAILED,
  DELETE_BRAND_BEGIN, DELETE_BRAND_SUCCESS, DELETE_BRAND_FAILED
} = actions;

const initState = {
  vehicleBrands: [],
  brands: [],
  total: 0,
  currentPage: 1,
  pageLimit: 50,
  loading: false,
  error: null
};

const BrandReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_BRAND_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_BRAND_SUCCESS:
      return {
        ...state,
        brands: data.brands,
        total: data.total || 0,
        currentPage: data.currentPage || 1,
        pageLimit: data.pageLimit || state.pageLimit,
        loading: data.currentPage ? false : true,
      };
    case GET_BRAND_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case GET_VEHICLES_BRAND_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_VEHICLES_BRAND_SUCCESS:
      return {
        ...state,
        vehicleBrands: data,
        loading: false,
      };
    case GET_VEHICLES_BRAND_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_BRAND_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_BRAND_SUCCESS:
      return {
        ...state,
        brands: data,
        total: state.total + 1,
        loading: false,
      };
    case ADD_BRAND_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_BRAND_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_BRAND_SUCCESS:
      return {
        ...state,
        brands: data,
        loading: false,
      };
    case UPDATE_BRAND_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_BRAND_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_BRAND_SUCCESS:
      return {
        ...state,
        brands: data,
        total: state.total - 1,
        loading: false,
      };
    case DELETE_BRAND_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default BrandReducer;